import { Heading } from '@boltenergy-be/design-system'
import styles from './Hero.module.scss'
import { useTranslation } from 'next-i18next/pages'
import StartSimulationCard from 'components/start-simulation-card/StartSimulationCard'
import heroImage from 'public/images/bolt-hero-windmill.webp'
import HeroImage from 'components/hero-image/HeroImage'
import { useRouter } from 'next/router'
import { HeroVariant } from 'features/home/Home.constants'

const Hero = ({ variant }: { variant: HeroVariant }) => {
  // i18n
  const { t } = useTranslation('home')

  // Router
  const { locale } = useRouter()

  return (
    <section data-color="dark" className={styles.hero} data-variant={variant}>
      <Heading as="h1" variant="d1" data-lang={locale} className={styles.title}>
        {t('home:hero.title.default')}
      </Heading>

      <StartSimulationCard className={styles['simulation-form']} />

      <div className={styles['image-overlay']} />
      <HeroImage src={heroImage} alt="" className={styles.image} />
    </section>
  )
}

export default Hero
